<template>
  <div id="app">

    <navigation-bar 
      :class = "{
        'navbar-hide' : true, 
        'navbar-show' : (this.$route.path != '/'), 
      }"
      
      class="navbar-about-bg"
    />

    <!--<div class="intro container-fluid">
      <div class="row">
        <div class="col-xs-push-1 col-xs-10">
          <img 
            class="img-responsive center-block" 
            src="./assets/ss-logo-silver-shadow.svg" 
            alt="Logo"
          >
          <h1>Welcome to the carrer portfolio of Aleks Ray !:)</h1>
        </div>
      </div>
    </div>-->

    <transition 
      name="fade" 
      mode="out-in"
    >
      <router-view/>
    </transition>
    
  </div><!-- end #app -->
</template>

<script>
import navigationBar from '@/components/NavigationBar.vue'
//import $ from 'jquery'
export default {
  components: {
    'navigation-bar': navigationBar
  },
  //mounted(){
  //  //console.log(this.$route);
  //  const intro = $('.intro');
  //  console.log('firstTime before if: ', sessionStorage.getItem('firstTime'));

  //  if(!sessionStorage.getItem('firstTime'))
  //  {
  //    intro.show();//intro.css("display", "block");
  //    intro.find('> *').fadeIn(3000);
  //    setTimeout(() => {
  //      intro.fadeOut(2000);
  //    }, 5000);
  //  }
  //  else {
  //    intro.hide();
  //  }
  //  sessionStorage.setItem('firstTime', 'true');
  //  console.log('firstTime after if:', sessionStorage.getItem('firstTime'));
  //},//END mounted
}
</script>

<style>
html, #app {
  background: black;
}
#app {
  /*font-family: Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
  /*color: #2c3e50;*/
  min-height: 100vh;
  /*font-family: Garamond, serif;*/
  font-family: Georgia, serif;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.navbar-hide {
  opacity: 0;
  transition: opacity 0.5s ease;
}

.navbar-show {
  opacity: 1;
}

/*nav a.router-link-exact-active {
  color: #42b983;
}*/



/* Intro styles */
.intro {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;/* width and height are 100% so that the element takes the entire space in the browser*/
  position: fixed; /* top and left are 0 by default */
  background: #fafafa;
  z-index: 2; /* this is 1 so that it sits above everything else*/
  text-align: center;
}

.intro > * {
  display: none;
}

.intro h1 {
  color: black;
}

/* and (max-device-width : 1280px) */
@media only screen  and (orientation: landscape) {
    /* css rules */
    .intro img {
      width: 20vw;
    }
}
</style>
